<template>
    <Loading :loading="loading" class="min-h-app h-full">
        <Tech33AktienPaket
            v-if="product_group?.id === '9f6f9f52-af6b-4f01-ab5f-7136fd38a327' && region === 'de'"
            :product-group="product_group"
            :selected-product-variant="selectedProductVariant"
            :sorted-product-variants="filteredProductVariantsByFrequency(getProduct?.productVariants?.data)"
            @select-product="selectProduct"
            @add-to-cart="addToCart()"
        />
        <EuroTitans
            v-else-if="product_group?.id === '276c17aa-10da-4f6d-bf11-85bb1a8fe1b6' && region === 'de'"
            :product-group="product_group"
            :selected-product-variant="selectedProductVariant"
            :sorted-product-variants="filteredProductVariantsByFrequency(getProduct.productVariants.data)"
            @select-product="selectProduct"
            @add-to-cart="addToCart()"
        />
        <Altcoin
            v-else-if="product_group?.id === 'ed37ad48-a989-41ef-a3ac-a3fde438737a'"
            :product-group="product_group"
            :selected-product-variant="selectedProductVariant"
            :sorted-product-variants="filteredProductVariantsByFrequency(getProduct.productVariants.data)"
            @select-product="selectProduct"
            @add-to-cart="
                () => {
                    toggleSelectedWebinar = false;
                    addToCart();
                }
            "
            @add-webinar-to-cart="
                () => {
                    toggleSelectedWebinar = true;
                    selectWebinar();
                    addToCart();
                }
            "
        />
        <hype-aktien
            v-else-if="product_group?.id === '79e4c4be-cdde-4a2f-9f0f-84bb2f16ea15'"
            :product-group="product_group"
            :selected-product-variant="selectedProductVariant"
            :sorted-product-variants="filteredProductVariantsByFrequency(getProduct.productVariants.data)"
            @select-product="selectProduct"
            @add-to-cart="addToCart()"
            @add-webinar-to-cart="
                () => {
                    toggleSelectedWebinar = true;
                    selectWebinar();
                }
            "
        />
        <div v-else-if="product_group" class="flex flex-col min-h-app">
            <div :class="!mobileBuySectionOpen ? '!block h-full flex-grow' : 'hidden'">
                <div class="container mx-auto pt-12 pb-[120px] lg:pb-12">
                    <div class="grid grid-cols-1 lg:grid-cols-2 gap-16">
                        <div class="order-1 lg:order-1 col-span-1">
                            <ProductTOC class="block lg:hidden mb-6" />
                            <h1 class="xl3_bold">
                                {{ $translate(product_group.name) }}
                            </h1>
                            <div class="description-container" v-html="$translate(product_group.description)"></div>
                        </div>

                        <div class="order-2 lg:order-2 col-span-1 flex flex-col gap-6">
                            <SimilarProducts
                                v-if="!loading"
                                :except="product_group.id"
                                :category="product_group.productCategories.data[0]"
                                class="overflow-hidden p-2"
                                @product-click="onSimilarProductClick"
                            />

                            <div v-if="product_group.meta?.shopifyProductIds?.length > 0" class="md:flex flex-wrap">
                                <div v-for="shopifyProductId in product_group.meta?.shopifyProductIds" class="m-2 lg:max-w-[13rem]">
                                    <ShopifyProduct :key="shopifyProductId" :product-id="shopifyProductId" />
                                </div>
                            </div>

                            <ProductTOC class="hidden lg:block sticky top-20 max-h-[calc(70vh-7rem)] overflow-y-auto" />
                        </div>

                        <div class="order-3 col-span-1 lg:col-span-2">
                            <Tabs v-if="product_group.content.length" :data="product_group.content" active-color="#353CEE" :active-tab="0" :first-on-load="true">
                                <template #header="{ data }">
                                    <h2 class="base_bold whitespace-nowrap">
                                        {{ $translate(data.attributes.title) }}
                                    </h2>
                                </template>

                                <template #item="{ data }">
                                    <div v-if="data.layout === 'tab_two_columns_wysiwyg'">
                                        <div class="grid grid-cols-1 lg:grid-cols-2 lg:gap-8">
                                            <div class="content text-justify" v-html="$translate(data.attributes.wysiwyg_left)" />
                                            <div class="content text-justify" v-html="$translate(data.attributes.wysiwyg_right)" />
                                        </div>
                                    </div>
                                    <div v-else class="content fr-view" v-html="$translate(data.attributes.wysiwyg)" />
                                </template>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Buy -->
            <div
                class="bg-white shadow-md w-full py-4 lg:block transition-all ease-in-out duration-500 origin-bottom lg:sticky bottom-0 lg:opacity-100 z-10"
                :class="mobileBuySectionOpen ? '!block min-h-screen' : 'h-0 lg:h-auto opacity-0 lg:opacity-100'"
            >
                <div class="container mx-auto">
                    <div class="grid grid-cols-1 lg:grid-cols-4 xl:grid-cols-5 gap-8">
                        <div class="col-span-1 lg:col-span-2 xl:col-span-3 relative">
                            <small>
                                {{ $translate(product_group.name) }}
                            </small>

                            <div ref="product_list" class="w-full">
                                <div class="lg:flex lg:flex-row items-center gap-4 grid grid-cols-2">
                                    <div
                                        v-for="productVariant in filteredProductVariantsByFrequency(getProduct.productVariants.data)"
                                        :key="productVariant.id"
                                        :class="selectedProductVariant === productVariant ? 'active' : ''"
                                        class="product-variant rounded-md shadow-md p-4 cursor-pointer relative my-3 whitespace-nowrap text-center transition-all ease-in-out"
                                        @click="selectProduct(productVariant)"
                                    >
                                        <div
                                            v-if="productVariant.discount_percent > 0"
                                            class="absolute -top-2 -right-2 rounded-full h-8 w-8 shadow-md flex items-center justify-center discount text-xxs"
                                        >
                                            <span>
                                                {{ $toPercent(productVariant.discount_percent, 0) }}
                                            </span>
                                        </div>
                                        <strong>
                                            {{ $translate(getAttributeByType(productVariant, 'period').title) }}
                                        </strong>
                                        <br />
                                        <small>
                                            {{ $toCurrency(productVariant.base_price_gross - productVariant.base_price_gross * productVariant.discount_percent) }}
                                        </small>
                                        <br />
                                        <span class="ml-1 text-xxs">
                                            {{ $t('per_month') }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <small class="text-xxxs italic text-gray-600">
                                {{ $t('payment_disclaimer') }}<br />
                                * {{ $t('payment_disclaimer_addon') }}
                            </small>
                        </div>
                        <!-- FIXME: Comment in to allow the User to choose the Frequency -->
                        <!-- <div class="col-span-1 flex flex-col">
                            <small>
                                {{ $t('Frequency') }}
                            </small>
                            <Toggle
                                :active="toggleSelectedFrequency"
                                @update:active="selectFrequency($event)"
                                :color="backgroundColor"
                                :colorGradient="backgroundGradient"
                                toggleClass="px-4"
                                :choices="getProductAttributesByType('frequency')"
                                class="h-full my-3">

                                <template #choice="{data}">
                                    <div class="flex flex-col items-center justify-center h-full">
                                        <span>
                                            {{ $translate(data.title) }}
                                        </span>
                                    </div>
                                </template>
                            </Toggle>
                        </div> -->
                        <div class="col-span-1">
                            <ProductWebinarOption
                                v-if="getWebinarVariantByPeriod(selectedPeriod)"
                                v-model:toggle-selected-webinar="toggleSelectedWebinar"
                                :selected-webinar="selectedWebinar"
                                :data="product_group"
                                :product-category="product_group.productCategories.data[0]"
                                @select-webinar="selectWebinar"
                            />
                        </div>
                        <div class="col-span-1">
                            <strong v-if="$store.getters['user/isBusinessUser']()"> {{ $t('payment_sum_excl_vat') }}: {{ $toCurrency(sumPriceGrossNet) }} </strong>
                            <strong v-if="$store.getters['user/isPrivateUser']()"> {{ $t('payment_sum_incl_vat') }}: {{ $toCurrency(sumPriceGross) }} </strong>
                            <br />
                            <small :class="sumDiscount ? '' : 'opacity-0'" class="block"> {{ $t('you_save') }}: {{ $toPercent(sumDiscount) }} </small>
                            <small :class="sumDiscount ? '' : 'opacity-0'" class="text-xxs block">
                                {{ $t('on_written_abonnement') }}
                            </small>
                            <FormButton
                                v-show="!mobileBuySectionOpen"
                                class="mb-0 mt-2 text-white"
                                styling="primary flex items-center gap-3 w-full justify-center text-xs xl"
                                :value="$t('payment_add_to_cart')"
                                @click="addToCart()"
                            >
                                <Icon type="Basket" viewBox="0 0 16 21" width="20" height="20" class="fill-current" />
                            </FormButton>
                        </div>
                    </div>
                </div>
            </div>
            <FormButton
                v-show="!mobileBuySectionOpen"
                class="mb-0 mt-2 text-white block lg:hidden w-full sticky bottom-0 z-10 xl"
                styling="xl bg-blue w-full rounded-b-none"
                :value="$t('payment_buy_now')"
                @click="openMobileBuySection()"
            >
            </FormButton>
            <FormButton
                v-show="mobileBuySectionOpen"
                class="mb-0 mt-2 text-white block lg:hidden w-full sticky bottom-0 z-10 xl"
                styling="xl bg-blue flex items-center justify-center gap-3 w-full rounded-b-none"
                :value="$t('payment_add_to_cart')"
                @click="addToCart()"
            >
                <Icon type="Basket" viewBox="0 0 16 21" width="20" height="20" class="fill-current" />
            </FormButton>
        </div>
    </Loading>
</template>

<script>
import { mapGetters } from 'vuex';
import i18next from 'i18next';
import _ from 'lodash';
import api from '../../api';
import ShopifyProduct from '../miscellaneous/ShopifyProducts.vue';
import Toastification from '../miscellaneous/Toastification.vue';
import ProductTOC from './ProductTOC.vue';
import ProductWebinarOption from './ProductWebinarOption.vue';
import Accordeon from '../miscellaneous/Accordeon.vue';
import PriceRow from './PriceRow.vue';
import CheckIcon from './CheckIcon.vue';
import ChevronIcon from './ChevronIcon.vue';
import FeatureItem from './FeatureItem.vue';
import FeatureCard from './FeatureCard.vue';
import Popup from '../miscellaneous/Popup.vue';
import Tech33AktienPaket from './Tech33AktienPaket.vue';
import EuroTitans from './EuroTitans.vue';
import HypeAktien from './HypeAktien.vue';
import Altcoin from './Altcoin.vue';

export default {
    components: {
        Altcoin,
        HypeAktien,
        Tech33AktienPaket,
        EuroTitans,
        Popup,
        Accordeon,
        ShopifyProduct,
        ProductTOC,
        ProductWebinarOption,
        FeatureItem,
        FeatureCard,
        PriceRow,
        CheckIcon,
        ChevronIcon
    },
    data: () => ({
        product_group: null,
        toggleSelectedFrequency: 0,
        toggleSelectedPeriod: 0,
        toggleSelectedWebinar: false,
        backgroundColor: null,
        backgroundGradient: null,
        selectedProductVariant: null,
        selectedWebinar: null,
        cartLoading: false,
        selectedPeriod: null,
        selectedFrequency: null,
        filteredProductVariants: [],
        mobileBuySectionOpen: false,
        loading: false,
        __viewItemPushed: false,
        faqs: [
            {
                question: 'Was bekomme ich mit einem Abonnement des TECH 33 Pakets?',
                answer: 'Mit dem TECH33-Paket erhalten Sie von Montag bis Freitag täglich eine Analyse von jeweils drei bis vier Aktien-Titeln aus dem TECH33-Portfolio.0 Alle 2 Wochen übermitteln wir Ihnen somit Analysen zu allen 33 Titeln des TECH33-Pakets. Die Analysen beinhalten konkrete Zielzonen und verständlich erklärte Chartbilder auf Basis der Elliott-Wellen-Analyse. Zusätzlich informiert Sie die HKCM per Push-Benachrichtigung und E-Mail über außergewöhnliche Markbewegungen, Einstiege, Stoppsetzungen und Gewinnmitnahmen. Alle Inhalte stehen Ihnen stets und dauerhaft im HKCM-Dashboard und in unserer App zur Verfügung. Das integrierte Musterportfolio zeigt alle Einstiege, Ausstiege, Nachkäufe und Stopps. '
            },
            {
                question: 'Wie kann ich mein TECH 33 HKCM-Abonnement beenden?',
                answer: "Kündigen Sie Ihr Abonnement direkt in Ihrem HKCM-Dashboard. Loggen Sie sich ein, wählen Sie in der Menüleiste 'Profil', klicken Sie auf 'Abonnements' und anschließend auf 'Abonnements verwalten'. Dort können Sie mit einem Klick auf 'Kündigen' Ihr gewünschtes Abonnement beenden. Bitte beachten Sie die Kündigungsfrist von 5 Tagen vor Ende der gebuchten Laufzeit."
            },
            {
                question: 'Wie viel kostet das das TECH33-Aktienpaket?',
                answer: 'Das TECH33-Paket ist in vier Laufzeiten mit gestaffelten Monatspreisen erhältlich: <br/><br/>● Laufzeit 1 Monat: 99,95 € pro Monat <br/><br/>● Laufzeit 3 Monate: 94,95 € pro Monat (5 % Rabatt) <br/><br/>● Laufzeit 6 Monate: 89,96 € pro Monat (10 % Rabatt) <br/><br/>● Laufzeit 1 Jahr: 84,96 € pro Monat (15 % Rabatt). <br/><br/> Alle Abonnements verlängern sich nach Ablauf automatisch um die jeweils gebuchte Laufzeit. '
            },
            {
                question: 'Wie kann ich bei HKCM bezahlen?',
                answer: 'Die HKCM bietet folgende Zahlungsmethoden an:<br/><br/>● Kreditkarte (z. B. Mastercard, Visa)<br/><br/>● PayPal<br/><br/>● Apple Pay<br/><br/>● Google Pay<br/><br/>Alle Optionen stehen Ihnen direkt im Bestellprozess auf der Webseite zur Auswahl.'
            },
            {
                question: 'Kann ich das TECH 33 Paket von HKCM in der HKCM-App buchen?',
                answer: 'Unsere Pakete können ausschließlich über die HKCM-Webseite gebucht werden. In der App können Sie bestehende Abonnements einsehen und verwalten, aber kein neues TECH33-Abo abschließen. '
            },
            {
                question: 'Verlängert sich das TECH 33-Abonnement automatisch?',
                answer: 'Ja, das TECH33-Paket verlängert sich automatisch um die gewählte Laufzeit, wenn es nicht vorher gekündigt wird.'
            },
            {
                question: 'Was ist die HKCM?',
                answer: 'HKCM steht für Hopf-Klinkmüller Capital Management. Das Unternehmen bietet professionelle Finanzanalysen auf Basis der Elliott-Wellen-Theorie an. Unsere Analysepakete bieten Ihnen klare Marktanalysen zu Aktien, Indizes, Kryptowährungen und Rohstoffen. '
            }
        ],

        region: null,
        pricingCardInView: false,
        marketingModalOpen: false
    }),

    mounted() {
        const that = this;
        this.loading = true;
        this.init().then(async () => {
            that.loading = false;

            // DOM fertig
            await that.$nextTick();

            // >>> view_item push
            if (!that.__viewItemPushed && typeof window !== 'undefined') {
                this.pushViewItem(this.product_group, this.selectedProductVariant);
                this.__viewItemPushed = true;
            }

            // IntersectionObserver für das Pricing-Card-Viewport-Tracking
            try {
                const el = document.getElementById('pricing-card');

                if (el) {
                    this._pricingCardObserver = new IntersectionObserver(
                        (entries) => {
                            const entry = entries[0];
                            this.pricingCardInView = entry.isIntersecting;
                        },
                        { root: null, threshold: 0.1 }
                    );
                    this._pricingCardObserver.observe(el);
                } else {
                    // Falls das Element noch nicht im DOM ist, nochmal nach dem nächsten Tick prüfen
                    await that.$nextTick();
                    const el2 = document.getElementById('pricing-card');

                    if (el2) {
                        this._pricingCardObserver = new IntersectionObserver(
                            (entries) => {
                                this.pricingCardInView = entries[0].isIntersecting;
                            },
                            { root: null, threshold: 0.1 }
                        );
                        this._pricingCardObserver.observe(el2);
                    }
                }
            } catch (e) {}
        });
        // get region
        this.region = window.meta.region_configuration.region || 'de';
    },

    methods: {
        async init() {
            this.toggleSelectedWebinar = false;
            this.selectedWebinar = null;

            return await api.get(`/api/v1/slugs/${this.$route.params.id}`).then(async (response) => {
                await this.$store.dispatch('product_group/show', response.data.data.id).then((response) => {
                    this.product_group = response.data;

                    this.backgroundColor = this.product_group.productCategories.data[0].background_color;
                    this.backgroundGradient = this.product_group.productCategories.data[0].background_gradient;

                    // preselect the first product on load
                    this.selectedProductVariant = _.first(this.filteredProductVariantsByFrequency(this.getProduct?.productVariants?.data || []));
                    this.updateVariantFrequencyPeriodValues();

                    const title = this.$translate(this.product_group.meta_title);
                    const description = this.$translate(this.product_group.meta_description);
                    const image = this.$translate(this.product_group.image);

                    document.title = this.$translate(this.product_group.name);

                    if (title != null) {
                        document.querySelector('meta[itemprop="name"]').setAttribute('content', title);
                        document.querySelector('meta[name="twitter:title"]').setAttribute('content', title);
                        document.querySelector('meta[name="og:title"]').setAttribute('content', title);
                    }

                    if (description != null) {
                        document.querySelector('meta[name="description"]').setAttribute('content', description);
                        document.querySelector('meta[name="twitter:description"]').setAttribute('content', description);
                        document.querySelector('meta[name="og:description"]').setAttribute('content', description);
                    }

                    if (image != null) {
                        document.querySelector('meta[name="og:image"]').setAttribute('content', image);
                        document.querySelector('meta[name="twitter:image:src"]').setAttribute('content', image);
                    }
                });
            });
        },

        onSimilarProductClick(pg, variant) {
            // Nur navigieren (oder was immer du sonst tun willst)
            // this.$router.push({ name: 'product', params: { id: pg.slug?.name || pg.id } });
            // Kein GA push hier – das macht das Child (select_item)
        },

        async addToCart() {
            const products = [];
            this.cartLoading = true;

            if (this.selectedProductVariant) {
                products.push(this.selectedProductVariant);
            }

            if (this.selectedWebinar && this.toggleSelectedWebinar === true) {
                products.push(this.selectedWebinar);
            }

            for (const selectedProductVariant of products) {
                await this.$store
                    .dispatch('cart_products/store', {
                        product_variant_id: selectedProductVariant.id,
                        __ga: {
                            // Herkunft im Funnel
                            item_list_name: 'Product Detail – Buy Box',
                            // saubere Produkt-Metadaten vom Detail
                            product_slug: this.product_group?.slug?.name,
                            product_name: this.$translate(this.product_group?.name) || this.product_group?.name?.de || this.product_group?.name,
                            category_name:
                                this.$translate(this.product_group?.productCategories?.data?.[0]?.name) ||
                                this.product_group?.productCategories?.data?.[0]?.name?.de ||
                                this.product_group?.productCategories?.data?.[0]?.name,
                            currency: (this.$getCurrencyCode && this.$getCurrencyCode()) || 'EUR'
                        }
                    })
                    .then((response) => {
                        // if no message in response the product was added succesfully
                        if (!response?.meta?.message) {
                            this.$toast.success({
                                component: Toastification,
                                props: {
                                    message: i18next.t('succesfully_added_to_cart'),
                                    type: 'success'
                                }
                            });
                        }
                    });
            }

            this.$store.dispatch('cart/index').then(() => {
                this.$store.commit('settings/openSidebar', { name: 'cart_sidebar' });
            });

            this.cartLoading = false;
        },

        getAttributeByType(productVariant, type) {
            return productVariant.productAttributeValues.data.find((productAttributeValue) => {
                return productAttributeValue.meta.type === type;
            });
        },

        filteredProductVariantsByFrequency(productVariants) {
            let filteredProductVariants = [];
            const frequency = this.getProductAttributesByType('frequency')[this.toggleSelectedFrequency].meta.frequency;

            productVariants.forEach((productVariant) => {
                productVariant.productAttributeValues.data.find((productAttributeValue) => {
                    if (productAttributeValue.meta.type === 'frequency' && productAttributeValue.meta.frequency === frequency) {
                        filteredProductVariants.push(productVariant);
                    }
                });
            });

            // sort the product Variants by Period
            filteredProductVariants = _.sortBy(filteredProductVariants, (filteredProductVariant) => {
                const productAttributeValue = filteredProductVariant.productAttributeValues.data.find((productAttributeValue) => {
                    return productAttributeValue.meta.type === 'period';
                });

                return productAttributeValue.meta.runtime_in_days;
            });

            return filteredProductVariants;
        },

        selectProduct(productVariant) {
            this.selectedProductVariant = productVariant;

            this.updateVariantFrequencyPeriodValues();

            // find corresponding webinar for product
            this.selectWebinar();

            // GA4: Variant-Auswahl auf der Produktdetailseite melden
            this.pushSelectItem(this.product_group, this.selectedProductVariant, 'Product Detail — Select Variant');
        },

        selectWebinar() {
            this.toggleSelectedWebinar ? (this.selectedWebinar = this.getWebinarVariantByPeriod(this.selectedPeriod)) : (this.selectedWebinar = null);
        },

        selectFrequency(frequency) {
            this.toggleSelectedFrequency = frequency;
            const filteredProductVariants = this.filteredProductVariantsByFrequency(this.getProduct.productVariants.data);
            let foundProductVariant = null;

            filteredProductVariants.forEach((productVariant) => {
                productVariant.productAttributeValues.data.forEach((productAttributeValue) => {
                    if (productAttributeValue.meta.type === 'period' && productAttributeValue.meta.runtime_in_days === this.selectedPeriod) {
                        foundProductVariant = productVariant;
                    }
                });
            });

            // set product with same frequency if exists with different period, else set the first available product
            foundProductVariant ? (this.selectedProductVariant = foundProductVariant) : (this.selectedProductVariant = _.first(filteredProductVariants));

            this.updateVariantFrequencyPeriodValues();

            // find corresponding webinar for product
            this.selectWebinar();

            // GA4: Frequenzwechsel (führt zu neuer Variantenauswahl) melden
            this.pushSelectItem(this.product_group, this.selectedProductVariant, 'Product Detail – Frequency');
        },

        updateVariantFrequencyPeriodValues() {
            // set the selected product period
            this.selectedPeriod = this.selectedProductVariant.productAttributeValues.data.find((productAttributeValues) => {
                return productAttributeValues.meta.type === 'period';
            }).meta.runtime_in_days;

            // set the selected product period
            this.selectedFrequency = this.selectedProductVariant.productAttributeValues.data.find((productAttributeValues) => {
                return productAttributeValues.meta.type === 'frequency';
            }).meta.frequency;
        },

        openMobileBuySection() {
            this.mobileBuySectionOpen = !this.mobileBuySectionOpen;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },

        buildGa4Item(productGroup, productVariant, index = 0) {
            if (!productGroup || !productVariant) return null;

            // dynamische ID
            const item_id = `${productVariant.id}`;

            // Name
            const item_name = (this.$translate && this.$translate(productGroup?.name)) || productGroup?.name?.de || productGroup?.name || 'Produkt';

            // Kategorie
            const item_category =
                (this.$translate && this.$translate(productGroup?.productCategories?.data?.[0]?.name)) ||
                productGroup?.productCategories?.data?.[0]?.name?.de ||
                productGroup?.productCategories?.data?.[0]?.name ||
                'Kategorie';

            // Variante (Perioden-Attribut)
            const periodAttr = this.getAttributeByType(productVariant, 'period');
            const item_variant = (this.$translate && this.$translate(periodAttr?.title)) || periodAttr?.title?.de || periodAttr?.title || 'Variante';

            // Preis wie im UI (Monatsbasis)
            const base = Number(productVariant?.base_price_gross ?? 0);
            const discountPercent = Number(productVariant?.discount_percent ?? 0);
            const price = Number((base - base * discountPercent).toFixed(2));

            const currency = (this.$getCurrencyCode && this.$getCurrencyCode()) || 'EUR';

            return {
                item_id,
                item_name,
                item_category,
                item_variant,
                price,
                currency,
                quantity: 1,
                index
            };
        },

        pushViewItem(productGroup, productVariant) {
            const item = this.buildGa4Item(productGroup, productVariant, 0);

            if (!item) return;

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: 'view_item',
                ecommerce: {
                    item_list_name: 'Product Detail',
                    currency: item.currency,
                    value: item.price,
                    items: [item]
                }
            });
        },

        pushSelectItem(productGroup, productVariant, listName = 'Similar Products') {
            const item = this.buildGa4Item(productGroup, productVariant, 0);

            if (!item) return;

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: 'select_item',
                ecommerce: {
                    item_list_name: listName,
                    items: [item]
                }
            });
        },

        closeAction() {
            this.marketingModalOpen = false;
        }
    },
    computed: {
        ...mapGetters('product_category', {
            getCategoryById: 'getCategoryById'
        }),
        ...mapGetters('product_group', {
            getProductGroup: 'get',
            getProduct: 'getProduct',
            getWebinar: 'getWebinar',
            getWebinarVariantByPeriod: 'getWebinarVariantByPeriod',
            getProductAttributesByType: 'getProductAttributesByType'
        }),
        ...mapGetters('product_groups', {
            getProductGroupByProductCategoryId: 'getByProductCategoryId'
        }),
        ...mapGetters('cart_products', {
            getCartProductsMeta: 'getMeta'
        }),
        sumPriceGrossNet() {
            let sumPrice = 0;

            if (this.selectedProductVariant) {
                sumPrice += this.selectedProductVariant.total_price_net;
            }

            if (this.selectedWebinar) {
                sumPrice += this.selectedWebinar.total_price_net;
            }

            return sumPrice;
        },
        sumPriceGross() {
            let sumPrice = 0;

            if (this.selectedProductVariant) {
                sumPrice += this.selectedProductVariant.total_end_price_gross;
            }

            if (this.selectedWebinar) {
                sumPrice += this.selectedWebinar.total_end_price_gross;
            }

            return sumPrice;
        },
        sumDiscount() {
            let sumDiscount = 0;

            if (this.selectedProductVariant) {
                sumDiscount += this.selectedProductVariant.discount_percent;
            }

            if (this.selectedWebinar) {
                sumDiscount += this.selectedWebinar.discount_percent;
            }

            return sumDiscount;
        },
        background() {
            return 'linear-gradient(to bottom, ' + this.backgroundColor + ' 0%, ' + this.backgroundGradient + ' 100%)';
        }
    },
    watch: {
        getCartProductsMeta: function () {
            _.forEach(this.getCartProductsMeta?.message, (message, type) => {
                this.$toast[type === 'danger' ? 'error' : type]({
                    component: Toastification,
                    props: {
                        message,
                        type: type === 'danger' ? 'error' : type
                    }
                });
            });
        },
        '$route.fullPath': function () {
            if (this.$route.params.id) {
                this.init();
            }
        }
    },
    beforeUnmount() {
        if (this._pricingCardObserver) {
            this._pricingCardObserver.disconnect();
            this._pricingCardObserver = null;
        }
    }
};
</script>

<style scoped>
.discount {
    background: v-bind(background);
    color: #ffffff;
}

.product-variant.active {
    background: v-bind(background);
    color: #ffffff;
}
</style>
